module.exports = "https://cdn.realtymogul.com/static/media/quickly.2b3474f7.svg";